import React, { useState } from "react";
import Layout from "../form-layout";

const OPTIONS = [
  "I am continuing my treatment and looking to move to the next higher dose.",
  "I am on a stable dose and want to maintain my current treatment.",
  "I am switching from a different weight loss medication (e.g., Wegovy to Mounjaro).",
  "I am experiencing side effects on my current dose and need clinical advice.",
  "Price / Stock availability issue at my previous provider.",
  "Other",
];

// Q18 — "Why are you requesting a prescription from our clinic today?" End of the
// kept GLP-1 follow-up pathway; routes into the pregnancy gate / additional info next.
export default function Step18({ formData, setFormData, onBack, goToStep }) {
  const [reason, setReason] = useState(formData.glp1FollowupReason || "");
  const [otherText, setOtherText] = useState(formData.glp1FollowupReasonOther || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!reason) return;
    if (reason === "Other" && !otherText.trim()) return;

    setFormData((prev) => ({
      ...prev,
      glp1FollowupReason: reason,
      glp1FollowupReasonOther: otherText,
    }));
    localStorage.setItem("glp1FollowupReason", reason);
    localStorage.setItem("glp1FollowupReasonOther", otherText);

    goToStep(formData.biologicalSex === "Female" ? "pregnancyGate" : "additionalInfo");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        Why are you requesting a prescription from our clinic today?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        {OPTIONS.map((option) => (
          <label key={option} className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
            <input
              type="radio"
              name="glp1FollowupReason"
              checked={reason === option}
              onChange={() => setReason(option)}
              className="h-4 w-4 accent-sky-400 cursor-pointer"
            />
            <span>{option}</span>
          </label>
        ))}

        {reason === "Other" && (
          <input
            type="text"
            value={otherText}
            onChange={(e) => setOtherText(e.target.value)}
            placeholder="Please specify"
            className="border-2 border-sky-400 rounded-md p-2 text-sm w-full"
          />
        )}

        <div className="flex justify-start mt-2">
          <button
            type="submit"
            disabled={!reason || (reason === "Other" && !otherText.trim())}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${
                !reason || (reason === "Other" && !otherText.trim())
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
              }`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
